 <div class="spinner-border {{ size }}" role="status"></div> 